import {FaDownload, FaUpload, FaTrash, FaArrowRotateLeft} from "react-icons/fa6";
import AuditableInfo from "../AuditableInfo";
import IconButton from "../form/IconButton";
import SkeletonLoader from "../SkeletonLoader";
import {getFileSizeFromBytes, truncateText} from "../../../helpers/utils/TextUtils";
import {getEnumDisplayNameByConstant} from "../../../helpers/utils/EnumUtils";
import {useGetEnumsQuery} from "../../../app/globalApi";

// @ts-ignore   
import image from "../../../images/txt.svg";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import {isValidCustomer} from "../../../helpers/utils/Utils";
import {useUtilDataQuery} from "../../../features/profile/profileApi";

interface SubdivisionNotes {
    id: string;
    comment: string;
    sortOrder: number;
}

interface SubdivisionNotesFormProps {
    data: SubdivisionNotes[];
    title: string;
    count: number;
    hasAddPermission: boolean;
    hasSortPermission: boolean;
    companyId?: any
    loading?: any
    error?: any,
    onClick?: any,
    setShowUploadDocModal?: any,
    setShowMultiDocSelectModal?: any,
    addPermission?: any,
    onDelete?: any,
    isLoading?: boolean,
    setShowYearSelectModal?: any,
    setSelectedDocId?: (id: string) => void;


}

const CommonDocumentsGrid: React.FC<SubdivisionNotesFormProps> = ({
                                                                      data,
                                                                      title,
                                                                      count,
                                                                      hasAddPermission,
                                                                      hasSortPermission,
                                                                      companyId,
                                                                      loading,
                                                                      error,
                                                                      onClick,
                                                                      setShowUploadDocModal,
                                                                      setShowMultiDocSelectModal,
                                                                      addPermission,
                                                                      onDelete,
                                                                      isLoading,
                                                                      setShowYearSelectModal,
                                                                      setSelectedDocId
                                                                  }) => {

    const iconButtonStyle = "cursor-pointer text-highlight-0 text-lg hover:text-highlight-7";
    const {data: enums} = useGetEnumsQuery("");
    const {data: utilData} = useUtilDataQuery("");

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                {/* Left-aligned h5 */}
                <h5 className="font-semibold text-surface-0">{title} ({count})</h5>

                {/* Right-aligned buttons */}
                <div className="flex">
                    {hasPermission(["FILEUPLOAD-V", addPermission]) && (
                        <IconButton
                            icon={<FaUpload onClick={() => setShowUploadDocModal(true)}/>}
                            className="text-sm"
                            title="Upload"
                        />
                    )}
                    <IconButton icon={<FaDownload onClick={() => setShowMultiDocSelectModal(true)}/>}
                                className="text-sm" title="Download"/>
                </div>
            </div>
            <div className={'p-2'}>
                <div className='overflow-y-auto max-h-96'>
                    {
                        (loading) ?
                            <SkeletonLoader className={"mt-2"} count={3}></SkeletonLoader> :
                            !error && data?.length === 0 ?
                                <div className="mt-1 border-2 border-surface-5 bg-text-0 p-2 rounded-sm">
                                    <h3>
                                        No documents to display
                                    </h3>
                                </div>
                                :
                                !error && data?.map((data: any) => {
                                    return <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                        <div className="grid-cols-12 lg:grid sm:block">
                                            <div className="col-span-6 ">
                                                <div className="flex gap-2">
                                                    <div
                                                        className="text-ellipsis cursor-pointer text-highlight-4 hover:text-highlight-7"

                                                    ><p className="m-0" onClick={() => {
                                                        onClick && onClick({
                                                            id: data.id,
                                                            shouldOpen: true,
                                                            isDownload: false,
                                                            filename: data.filename,
                                                            tgxFileType: data.tgxFileType,
                                                            fileSize: data.fileSize,
                                                            fileType: data.fileType
                                                        });
                                                    }}>
                                                        {truncateText(data?.filename, 48)}
                                                    </p>

                                                        <div className="flex justify-between items-center">
                                                            <div className="flex gap-2 items-center">
                                                                <h3 className="text-surface-2">
                                                                    <span
                                                                        className="cursor text-color"

                                                                    >
                                                                        {data?.fileDataType}
                                                                    </span>

                                                                </h3>
                                                                <h3 className="text-text-2 italic">
                                                                    {getEnumDisplayNameByConstant(enums?.OrderFileType, data?.fileType)} ({getFileSizeFromBytes(data?.fileSize, 0)})
                                                                </h3>
                                                            </div>

                                                        </div>


                                                        <div>
                                                            {hasPermission(["FILE-U", "FILE-V", "FILE-D"]) &&
                                                                (isValidCustomer(utilData) ||
                                                                    (utilData?.customerLevel === "CUSTOMER" &&
                                                                        data.creatorCustomerId === utilData?.customer_Id
                                                                    )) && (
                                                                    <div className="flex items-center">
                                                                        <IconButton
                                                                            icon={<FaDownload/>}
                                                                            className="text-sm"
                                                                            title="Download"
                                                                            onClick={() => {
                                                                                onClick && onClick({
                                                                                    id: data.id,
                                                                                    shouldOpen: false,
                                                                                    isDownload: true,
                                                                                    filename: data.filename,
                                                                                    tgxFileType: data.tgxFileType,
                                                                                    fileSize: data.fileSize,
                                                                                    fileType: data.fileType
                                                                                });
                                                                            }}
                                                                        />
                                                                        {title === "Subdivision Documents" && hasPermission(["SUBDFIL-D"]) &&
                                                                            <IconButton
                                                                                icon={<FaTrash/>}
                                                                                className="text-sm"
                                                                                title="Delete"
                                                                                onClick={() => {
                                                                                    onDelete && onDelete(
                                                                                        data.id
                                                                                    );
                                                                                }}
                                                                            />
                                                                        }
                                                                        {title === "Collector Documents " && (
                                                                            <IconButton
                                                                                icon={<FaArrowRotateLeft />}
                                                                                className="text-sm"
                                                                                title="Dispatch Job"
                                                                                onClick={() => {
                                                                                    setSelectedDocId && setSelectedDocId(data.id);
                                                                                    setShowYearSelectModal && setShowYearSelectModal(true);

                                                                                }}                                                                            />
                                                                        )}


                                                                    </div>
                                                                )}
                                                        </div>


                                                    </div>

                                                </div>


                                            </div>
                                            <div className="col-span-6 text-sm text-end">
                                                <AuditableInfo data={data}/>
                                            </div>
                                        </div>
                                    </div>
                                })

                    }
                </div>
            </div>


        </div>


    );
};

export default CommonDocumentsGrid;
